import { usePageType } from '@app/page';
import { PageType } from '@app/config';
import { useIsNonInteractiveViewer } from '@app/ui';

const useContentWrapper = () => {
  const isNonInteractiveViewer = useIsNonInteractiveViewer();
  const isHomePage = usePageType() === PageType.Home;

  const classes = {
    'blog-header': isNonInteractiveViewer,
    'home-page': isHomePage,
  };

  return {
    classes,
  };
};

export default useContentWrapper;
